import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/icon/arrow-bottom.png'
import _imports_2 from '@/assets/icon/icon-my.png'
import _imports_3 from '@/assets/icon/menu.png'


const _withScopeId = n => (_pushScopeId("data-v-561685a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "left-box d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo img-render-optimize",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_4 = { class: "left-container" }
const _hoisted_5 = {
  key: 0,
  class: "search-wrapper input-group"
}
const _hoisted_6 = { class: "right-box d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "sign-container align-items-center d-none d-lg-flex" }
const _hoisted_8 = {
  class: "user-name",
  to: { name: 'mine' },
  "data-bs-toggle": "dropdown"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = {
  class: "dropdown-item",
  href: "javascript:void(0)"
}
const _hoisted_11 = {
  key: 0,
  class: "select-language d-none d-lg-flex"
}
const _hoisted_12 = {
  id: "flag-dropdown",
  class: "language d-flex align-items-center pointer",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_1
}, null, -1))
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "flag-dropdown"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "xs-only-container" }
const _hoisted_20 = {
  key: 0,
  class: "menu-content hidden-xs-only"
}

import { reactive, computed, ref, onMounted, onUnmounted, watch } from 'vue';
  import PcMenu from './pc-menu.vue';
  import MovileMenu from './mobile-menu.vue';
  import MobileMineSidebar from './mobile-mine-sidebar.vue';
  import { authStore } from '@/stores';
  import { useRoute, useRouter, RouteRecordName } from 'vue-router';
  import { MENUS, countryList, currentCountry } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { goToLogin } from '@/utils';
  import { useElementBounding } from '@vueuse/core';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const mobileMenuVisible = ref(false);
  const mobileMineSideVisible = ref(false);
  const searchKey = ref('');
  const router = useRouter();
  const route = useRoute();
  const showSearch = computed(() => {
    if (!route.name) {
      return false;
    }
    const list: RouteRecordName[] = ['home'];
    return list.includes(route.name);
  });

  const menus = reactive(MENUS);

  function handleToggleLogin() {
    if (authStore.isLogin) {
      authStore.signOut();
      router.replace({ name: 'login' });
    } else {
      goToLogin();
    }
  }

  function handleClickMine() {
    if (!authStore.isLogin) {
      goToLogin();
      return;
    }
    mobileMineSideVisible.value = true;
  }

  function handleSearch() {
    router.push({ name: 'search', query: { keyword: searchKey.value } });
  }

  function handleLanguage(item: any) {
    if (item.link && item.link !== location.origin) {
      location.href = item.link;
    }
  }

  function handleScanSuccess(content: string) {
    if (content.startsWith('http')) {
      window.location.href = content;
    }
  }

  onMounted(() => {
    if (authStore.isLogin) {
      authStore.tryFetchData();
    }
  });

  onUnmounted(() => {
    document.body.style.setProperty('--tc-header-height', '0px');
  });

  const headerRef = ref<HTMLDivElement>();
  const { height } = useElementBounding(headerRef);
  watch(
    () => height.value,
    (val) => {
      document.body.style.setProperty('--tc-header-height', `${val}px`);
    },
    {
      immediate: true
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_AppSsoLoginPartner = _resolveComponent("AppSsoLoginPartner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "app-header",
      ref_key: "headerRef",
      ref: headerRef,
      class: "header-wrapper"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "logo-cotainer",
            to: { name: 'home' }
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            (_unref(showSearch))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_AppSearch, {
                    modelValue: searchKey.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
                    modelModifiers: { trim: true },
                    scanner: "",
                    placeholder: _unref(t)('Search programs'),
                    onSearch: handleSearch,
                    "onScanner:change": handleScanSuccess
                  }, null, 8, ["modelValue", "placeholder"])
                ]))
              : (_openBlock(), _createBlock(PcMenu, {
                  key: 1,
                  menus: _unref(menus),
                  class: "d-none d-lg-flex"
                }, null, 8, ["menus"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_unref(authStore).isLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(authStore).user.company_account_id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_b_button, { variant: "link" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('mine_page')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("ul", _hoisted_9, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              class: "dropdown-item",
                              to: { name: 'mine' }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('mine_page')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_AppSsoLoginPartner, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)('Sign In Partner')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "user-name",
                        to: { name: 'mine' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_button, { variant: "link" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('mine_page')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_b_button, {
                    variant: "link",
                    onClick: handleToggleLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('Sign Out')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_b_button, {
                  key: 1,
                  variant: "link",
                  onClick: handleToggleLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('Sign in')), 1)
                  ]),
                  _: 1
                }))
          ]),
          (_unref(countryList).length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    class: "flag",
                    src: _unref(currentCountry).icon,
                    alt: "flag"
                  }, null, 8, _hoisted_13),
                  _hoisted_14
                ]),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryList), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "dropdown-item",
                      onClick: ($event: any) => (handleLanguage(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.icon,
                        class: "flag"
                      }, null, 8, _hoisted_17),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(item.text), 1)
                    ], 8, _hoisted_16))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              class: "user",
              src: _imports_2,
              alt: "user",
              onClick: handleClickMine
            }),
            _createElementVNode("img", {
              src: _imports_3,
              class: "menu-icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuVisible.value = true))
            })
          ])
        ])
      ]),
      (_unref(showSearch))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(PcMenu, { menus: _unref(menus) }, null, 8, ["menus"])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createVNode(MovileMenu, {
      visible: mobileMenuVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((mobileMenuVisible).value = $event)),
      menus: _unref(menus)
    }, null, 8, ["visible", "menus"]),
    _createVNode(MobileMineSidebar, {
      visible: mobileMineSideVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((mobileMineSideVisible).value = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})